import { CloseOutlined, NearMeOutlined, PlaceOutlined, SignalWifiConnectedNoInternet4Outlined } from '@mui/icons-material'
import { Alert, Avatar, Box, Button, ButtonBase, Card, CardContent, CircularProgress, ClickAwayListener, Collapse, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Paper, Select, Stack, TextField, Typography, useTheme, Checkbox } from '@mui/material'
import { useCallback, useEffect, useRef, useState } from 'react'

export default function QuoteForm({ addresses, getAddresses, recipient, setRecipient, hasRecipientSelected, setHasRecipientSelected, sender, setSender, hasSenderSelected, setHasSenderSelected, packet, setPacket, shipment, setShipment, setValidatedForm, irregular, setIrregular, insuranceRequired, setInsuranceRequired }) {
  function validateNumber(value) {
    const regex = /^\d{0,8}(\.\d{0,2})?$/
    return regex.test(value)
  }

  useEffect(() => {
    if (packet.esSobre === 1) {
      // packet.peso = 1
      packet.alto = 1
      packet.ancho = 1
      packet.largo = 1
      setIrregular(0)
      setInsuranceRequired(0)
    }
  }, [packet.esSobre])

  useEffect(() => {
    let validated = true

    if (!/^\d{5}$/.test(sender.codigoPostal)) {
      validated = false
    }

    if (!/^\d{5}$/.test(recipient.codigoPostal)) {
      validated = false
    }

    if (shipment.mercancia>50000 ||/^\s*(\.\s*)?$/.test(shipment.mercancia)) {
      validated = false
    }

    if (Number(packet.peso) <= 0 || /^\s*(\.\s*)?$/.test(packet.peso)) {
      validated = false
    }

    if (packet.esSobre === 0) {
      if (Number(packet.alto) <= 0 || /^\s*(\.\s*)?$/.test(packet.alto)) {
        validated = false
      }

      if (Number(packet.ancho) <= 0 || /^\s*(\.\s*)?$/.test(packet.ancho)) {
        validated = false
      }

      if (Number(packet.largo) <= 0 || /^\s*(\.\s*)?$/.test(packet.largo)) {
        validated = false
      }
    }

    setValidatedForm(validated)
  }, [sender.codigoPostal, recipient.codigoPostal, shipment.mercancia, packet.esSobre, packet.alto, packet.ancho, packet.largo, packet.peso])

  return (
    <>
      <Stack
        spacing={2}
        useFlexGap
      >
        <Typography variant='body1'>Introduce el código postal de origen y destino</Typography>

        <AddressesSearch
          label='Código postal de origen'
          addresses={addresses}
          address={sender}
          setAddress={setSender}
          hasSelected={hasSenderSelected}
          setHasSelected={setHasSenderSelected}
          reloadAddresses={getAddresses}
          avatar={<PlaceOutlined />}
        />

        <AddressesSearch
          label='Código postal de destino'
          addresses={addresses}
          address={recipient}
          setAddress={setRecipient}
          hasSelected={hasRecipientSelected}
          setHasSelected={setHasRecipientSelected}
          reloadAddresses={getAddresses}
          avatar={<NearMeOutlined />}
        />

        <Typography variant='body1'>Detalles del envio</Typography>

        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
          >
            <FormControl fullWidth>
              <InputLabel id='packet-selector-label'>Tipo de envío</InputLabel>
              <Select
                value={packet.esSobre}
                label='Tipo de envío'
                onChange={event => setPacket({ ...packet, esSobre: event.target.value })}
              >
                <MenuItem value={1}>Sobre</MenuItem>
                <MenuItem value={0}>Paquete</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={4}
          >
            <TextField
              variant='outlined'
              value={shipment.mercancia}
              onChange={event => {
                const value = event.target.value
                if (validateNumber(value)) {
                  setShipment({ ...shipment, mercancia: value })
                }
              }}
              label='Valor de la mercancía'
              type='text'
              InputProps={{
                startAdornment: <InputAdornment position='start'>$</InputAdornment>
              }}
              fullWidth
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={4}
          >
            <TextField
              variant='outlined'
              value={packet.peso}
              onChange={event => {
                const value = event.target.value
                if (validateNumber(value)) {
                  setPacket({ ...packet, peso: value })
                }
              }}
              label='Peso del paquete'
              InputProps={{
                endAdornment: <InputAdornment position='end'>kg</InputAdornment>
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </Stack>

      <Collapse in={packet.esSobre === 0}>
        <Grid
          container
          spacing={2}
          sx={{ marginTop: 1 }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
          >
            <TextField
              variant='outlined'
              value={packet.alto}
              onChange={event => {
                const value = event.target.value
                if (validateNumber(value)) {
                  setPacket({ ...packet, alto: value })
                }
              }}
              label='Altura del paquete'
              InputProps={{
                endAdornment: <InputAdornment position='end'>cm</InputAdornment>
              }}
              fullWidth
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
          >
            <TextField
              variant='outlined'
              value={packet.ancho}
              onChange={event => {
                const value = event.target.value
                if (validateNumber(value)) {
                  setPacket({ ...packet, ancho: value })
                }
              }}
              label='Ancho del paquete'
              InputProps={{
                endAdornment: <InputAdornment position='end'>cm</InputAdornment>
              }}
              fullWidth
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
          >
            <TextField
              variant='outlined'
              value={packet.largo}
              onChange={event => {
                const value = event.target.value
                if (validateNumber(value)) {
                  setPacket({ ...packet, largo: value })
                }
              }}
              label='Largo del paquete'
              InputProps={{
                endAdornment: <InputAdornment position='end'>cm</InputAdornment>
              }}
              fullWidth
            />
          </Grid>
        </Grid>
        
        <Alert
          severity='warning'
          sx={{ marginTop: 2 }}
        >
          Porfavor consulte son su proveedor en cuales carriers esta disponible el seguro opcional
        </Alert>

        <Stack
          direction='row'
          alignItems='center'
          justifyContent='flex-start'
          spacing={1}
        >
          <Checkbox 
            checked={irregular}
            onChange={event => setIrregular(event.target.checked ? 1 : 0)}
          />
          <Typography
            fontSize='13px'
            fontWeight='700'
          >
            {irregular ? 'Se ha aplicado el precio predeterminado de paquete irregular' : '¿Es irregular el paquete?'}
          </Typography>
        </Stack>

        <Stack
          direction='row'
          alignItems='center'
          justifyContent='flex-start'
          spacing={1}
        >
          <Checkbox 
            checked={insuranceRequired}
            onChange={event => setInsuranceRequired(event.target.checked ? 1 : 0)}
          />
          <Typography
            fontSize='13px'
            fontWeight='700'
          >
            {insuranceRequired ? 'Se ha aplicado seguro al envio' : '¿Requiere asegurar?'}
          </Typography>
        </Stack>

        <Alert
          severity='info'
          sx={{ marginTop: 2 }}
        >
          Los valores decimales serán redondeados a su entero superior más próximo
        </Alert>
      </Collapse>
    </>
  )
}

// Helper para normalizar texto (quitar acentos y pasar a minúsculas)
const normalize = (str) =>
  (str ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

// Componente de resultados extraído fuera del render para evitar re-creación
const AddressesViewport = ({ filtered, addresses, onSelect, reloadAddresses }) => {
  if (filtered?.length > 0) {
    return (
      <Stack spacing={1}>
        {filtered.map(item => (
          <Card
            key={item.id.toString()}
            variant='outlined'
            onClick={() => onSelect(item)}
          >
            <ButtonBase sx={{ width: '100%' }}>
              <CardContent sx={{ width: '100%', textAlign: 'left' }}>
                <Typography
                  variant='body1'
                  sx={{ fontWeight: 'bold' }}
                >
                  {item.empresa ? `${item.empresa} - ` : ''}
                  {`${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno ?? ''}`.trim()}
                </Typography>
                <Typography variant='body1'>
                  {item.calle} {item.numeroExterior} {item.numeroInterior ? `int. ${item.numeroInterior}` : ''}
                </Typography>
                <Typography variant='body1'>
                  {item.colonia}, {item.municipio}. {item.codigoPostal}
                </Typography>
              </CardContent>
            </ButtonBase>
          </Card>
        ))}
      </Stack>
    )
  }

  if (addresses === null) {
    return (
      <Stack
        alignItems='center'
        spacing={1}
      >
        <SignalWifiConnectedNoInternet4Outlined sx={{ fontSize: 40 }} />
        <Typography>Tenemos problemas para recuperar tus domicilios guardados</Typography>
        <Button
          variant='outlined'
          onClick={() => reloadAddresses()}
        >
          Volver a intentar
        </Button>
      </Stack>
    )
  }

  return (
    <Stack
      alignItems='center'
      spacing={1}
    >
      <CircularProgress sx={{ fontSize: 40 }} />
      <Typography>Obteniendo tus domicilios guardados</Typography>
    </Stack>
  )
}

const MAX_RESULTS = 5

const AddressesSearch = ({ label, addresses, address, setAddress, hasSelected, setHasSelected, reloadAddresses, avatar }) => {
  const [open, setOpen] = useState(false)
  const [filtered, setFiltered] = useState([])
  const [inputValue, setInputValue] = useState('')
  const theme = useTheme()
  const debounceTimer = useRef(null)

  // Inicializar o limpiar el input según el estado del domicilio seleccionado
  useEffect(() => {
    if (address && Object.keys(address).length > 0) {
      setInputValue(address.codigoPostal || '')
    } else {
      setInputValue('')
    }
  }, [address])

  // Lógica local para filtrar las direcciones en memoria a un máximo de 5
  const localFilter = useCallback((searchTerm, list) => {
    const entry = normalize(searchTerm)
    if (!entry) {
      return list?.slice(0, MAX_RESULTS) ?? []
    }

    const results = []
    if (list) {
      for (let i = 0; i < list.length && results.length < MAX_RESULTS; i++) {
        const item = list[i]
        const fullName = normalize(`${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`)
        const company = normalize(item.empresa)
        const street = normalize(item.calle)
        const postalZip = item.codigoPostal ?? ''
        const phone = item.telefono1 ?? ''
        const altPhone = item.telefono2 ?? ''

        if (
          fullName.includes(entry) ||
          company.includes(entry) ||
          postalZip.includes(entry) ||
          phone.includes(entry) ||
          altPhone.includes(entry) ||
          street.includes(entry)
        ) {
          results.push(item)
        }
      }
    }
    return results
  }, [])

  // Actualizar la lista filtrada local cada vez que cambien los domicilios o el input
  useEffect(() => {
    setFiltered(localFilter(inputValue, addresses))
  }, [addresses, inputValue, localFilter])

  // Manejar el cambio del input de búsqueda con control de debounce
  const filterAddresses = useCallback((event) => {
    const value = event.target.value
    setInputValue(value)

    // Actualizar siempre el código postal en el estado para no causar un desajuste con el useEffect
    setAddress(prev => ({ ...prev, codigoPostal: value }))

    // Debounce de 500ms
    if (debounceTimer.current) clearTimeout(debounceTimer.current)

    debounceTimer.current = setTimeout(() => {
      // Requisito: Si tiene 3 caracteres o más, busca pasando el parámetro. Si tiene menos, limpia/restablece.
      if (value.trim().length >= 3) {
        reloadAddresses(value.trim())
      } else {
        reloadAddresses('')
      }
    }, 500)
  }, [reloadAddresses, setAddress])

  // Limpiar timer al desmontar
  useEffect(() => {
    return () => {
      if (debounceTimer.current) clearTimeout(debounceTimer.current)
    }
  }, [])

  const handleSelect = useCallback((item) => {
    setAddress(item)
    setHasSelected(true)
    setOpen(false)
    setFiltered(localFilter(item.codigoPostal || '', addresses))
  }, [addresses, setAddress, setHasSelected, localFilter])

  if (hasSelected === true) {
    return (
      <Stack
        direction='row'
        spacing={2}
      >
        <Avatar sx={{ mt: 1, bgcolor: theme.palette.primary.main }}>{avatar}</Avatar>

        <Card
          variant='outlined'
          sx={{ width: '100%' }}
        >
          <CardContent sx={{ textAlign: 'left' }}>
            <Grid container>
              <Grid
                item
                xs
              >
                <Typography
                  variant='body1'
                  sx={{ fontWeight: 'bold' }}
                >
                  {address.empresa ? `${address.empresa} - ` : ''}
                  {`${address.nombre} ${address.apellidoPaterno} ${address.apellidoMaterno ?? ''}`.trim()}
                </Typography>

                <Typography variant='body1'>
                  {address.calle} {address.numeroExterior} {address.numeroInterior ? `int. ${address.numeroInterior}` : ''}
                </Typography>

                <Typography variant='body1'>
                  {address.colonia}, {address.municipio}. {address.codigoPostal}
                </Typography>
              </Grid>

              <Grid item>
                <IconButton
                  onClick={() => {
                    setAddress({})
                    setHasSelected(false)
                    setInputValue('')
                    reloadAddresses('') // Restablecer al limpiar selección
                  }}
                >
                  <CloseOutlined />
                </IconButton>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Stack>
    )
  }

  return (
    <Stack
      direction='row'
      spacing={2}
    >
      <Avatar sx={{ mt: 1, bgcolor: theme.palette.primary.main }}>{avatar}</Avatar>

      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Box sx={{ position: 'relative', width: '100%' }}>
          <TextField
            variant='outlined'
            label={label}
            placeholder='También puedes buscar por nombre, empresa, teléfono o código postal'
            value={inputValue}
            onChange={filterAddresses}
            onFocus={() => setOpen(true)}
            onKeyDown={e => {
              if (e.key === 'Tab') setOpen(false)
            }}
            sx={{ zIndex: 0 }}
            inputProps={{
              maxLength: 30
            }}
            fullWidth
          />
          {open && (addresses === undefined || filtered?.length !== 0) && (
            <Paper
              elevation={10}
              sx={{ p: 2, position: 'absolute', zIndex: 10, maxHeight: 175, width: '100%', overflow: 'auto' }}
            >
              <AddressesViewport
                filtered={filtered}
                addresses={addresses}
                onSelect={handleSelect}
                reloadAddresses={() => reloadAddresses(inputValue)}
              />
            </Paper>
          )}
        </Box>
      </ClickAwayListener>
    </Stack>
  )
}
